export enum ExecutiveSummaryType {
	VEHICLES = 'vehicles',
	SAVINGS = 'savings',
	INFRASTRUCTURE = 'infrastructure',
}
